import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

const UPDATED_DATE = "16 October 2026";

function PolicyPage({ document }) {
  return (
    <main role="main" id="MainContent" className="main-content">
      <article className="shopify-policy__container">
        <header className="shopify-policy__title">
          <p className="policy-kicker">Hound &amp; Home policies</p>
          <h1>{document.title}</h1>
          <p className="policy-updated">
            Last updated: {document.updated || UPDATED_DATE}
          </p>
        </header>

        <div className="shopify-policy__body">
          <p className="policy-summary">{document.summary}</p>

          {document.notice && (
            <div className="policy-notice" role="note">
              {document.notice}
            </div>
          )}

          {document.sections.map((section, index) => (
            <section className="policy-section" key={section.heading}>
              <h2>
                {index + 1}. {section.heading}
              </h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.bullets && (
                <ul>
                  {section.bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
              {section.links && (
                <p className="policy-related-links">
                  {section.links.map((link, linkIndex) => (
                    <React.Fragment key={link.to}>
                      {linkIndex > 0 && " · "}
                      <Link to={link.to}>{link.label}</Link>
                    </React.Fragment>
                  ))}
                </p>
              )}
            </section>
          ))}

          <aside className="policy-contact">
            <h2>Questions about this policy?</h2>
            <p>
              Contact Hound &amp; Home at{" "}
              <a href="mailto:packs@houndandhome.xyz">
                packs@houndandhome.xyz
              </a>
              . Please include your order number where relevant.
            </p>
            <Link className="policy-index-link" to="/policies">
              View all policies
            </Link>
          </aside>
        </div>
      </article>
    </main>
  );
}

export default PolicyPage;
